import moment from 'moment'
import type { IntlShape } from 'react-intl'
import { INTL_DATE_TIME_FORMAT } from 'constants/dateFormats'
import { intlDateFormatter } from 'lib/datetime/dateUtils'

const deadlineFormat = { ...INTL_DATE_TIME_FORMAT, timeZoneName: 'short' } satisfies Intl.DateTimeFormatOptions

export function getScheduleChangeAirlineName(change: App.FlightScheduleChange, intl: IntlShape): string {
  return change.newLegs.find(leg => leg.id === change.affectedLegs[0]?.newLegId)?.flights[0]?.marketingAirline.name ?? intl.formatMessage({
    id: 'duUUupQLmU5Liux_lpl9',
    defaultMessage: 'Your airline',
    description: 'Fallback airline name used in the flight schedule change review banner when no name is supplied',
  })
}

export function formatScheduleChangeDeadline(change: App.FlightScheduleChange, locale: string): string {
  return intlDateFormatter(change.respondBy, deadlineFormat, locale, 'Australia/Sydney')
}

export function parseScheduleChangeDateTime(value: string) {
  // Snapshots contain airport-local wall clocks, not UTC instants.
  return moment.utc(value, 'DD/MM/YYYY-HH:mm', true)
}
